import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ReathletikGiveAccessRequestDto} from '../../dtos/reathletikGiveAccessRequest.dto';

@Injectable({
    providedIn: 'root'
})
export class ReathletikAdminService {

    constructor(private _httpClient: HttpClient) {}

    public giveAccessToProtocols(giveAccessDto: ReathletikGiveAccessRequestDto): Observable<void> {
        return this._httpClient.post<any>(environment.apiUrl + 'api/integration/reathletik/admin/v1/giveProtocolAccess', giveAccessDto);
    }
}
